import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import React from 'react';

function NameCell(props) {
  const { cell } = props;
  const field = cell.row?.values?.[cell.column.id] || {};
  return field.firstName && field.lastName ? (
    <div>{`${field.firstName} ${field.lastName}`}</div>
  ) : (
    <DisabledTag>NA</DisabledTag>
  );
}

export default NameCell;
